/*
 * Gzip text for checkpoint storage. Falls back to plain text where the
 * browser has no CompressionStream; `decode` accepts either form.
 */

const canCompress = typeof CompressionStream === "function" && typeof DecompressionStream === "function";

async function pipe(bytes, transform) {
    const stream = new Blob([bytes]).stream().pipeThrough(transform);
    return new Uint8Array(await new Response(stream).arrayBuffer());
}

/**
 * @param {string} text
 * @returns {Promise<Uint8Array|string>}
 */
export async function encodeText(text) {
    if (!canCompress) return text;
    return pipe(new TextEncoder().encode(text), new CompressionStream("gzip"));
}

/**
 * @param {Uint8Array|ArrayBuffer|string} data
 * @returns {Promise<string>}
 */
export async function decodeText(data) {
    if (typeof data === "string") return data;
    const bytes = data instanceof Uint8Array ? data : new Uint8Array(data);
    return new TextDecoder().decode(await pipe(bytes, new DecompressionStream("gzip")));
}
